const DRAFT_KEY = 'donation_checkout_draft'

export function saveDonationDraft(values = {}) {
  const draft = {
    product_id: values.product_id || '',
    product_name: values.product_name || '',
    donation_amount: values.donation_amount || '',
    donation_amount_info: values.donation_amount_info || '',
  }
  sessionStorage.setItem(DRAFT_KEY, JSON.stringify(draft))
}

export function loadDonationDraft() {
  const raw = sessionStorage.getItem(DRAFT_KEY)
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return null
    return parsed
  } catch (e) {
    return null
  }
}

export function clearDonationDraft() {
  sessionStorage.removeItem(DRAFT_KEY)
}
